import { Alert, Button, PasswordInput, Stack, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate, useSearchParams } from "react-router";
import { useLogin, useMe } from "../../api/auth";
import { useErrorText } from "../../api/errors";
import { AuthCard } from "./AuthCard";

/** Přihlášení loginem nebo e-mailem (F-AUTH-01); zůstává se přihlášen (F-AUTH-06). */
export function LoginPage() {
  const { t } = useTranslation();
  const errorText = useErrorText();
  const me = useMe();
  const login = useLogin();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = safeNext(params.get("next"));
  const form = useForm({ initialValues: { login: "", password: "" } });

  if (me.data) return <Navigate to={next} replace />;

  return (
    <AuthCard title={t("auth.login.title")}>
      <form
        onSubmit={form.onSubmit((values) =>
          login.mutate(values, { onSuccess: () => void navigate(next, { replace: true }) }),
        )}
      >
        <Stack>
          <TextInput
            label={t("auth.login.login")}
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            required
            {...form.getInputProps("login")}
          />
          <PasswordInput
            label={t("auth.login.password")}
            autoComplete="current-password"
            required
            size="lg"
            {...form.getInputProps("password")}
          />
          {login.isError && <Alert color="red">{errorText(login.error)}</Alert>}
          <Button type="submit" loading={login.isPending} fullWidth>
            {t("auth.login.submit")}
          </Button>
          <Text size="sm" c="dimmed">
            {t("auth.login.forgotten")}
          </Text>
        </Stack>
      </form>
    </AuthCard>
  );
}

/** Jen adresy v rámci aplikace (ochrana proti přesměrování na cizí web). */
function safeNext(next: string | null): string {
  return next && next.startsWith("/") && !next.startsWith("//") ? next : "/";
}
